import React, { Component } from "react";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";

class MarianRetreatCentrePage extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container-fluid position-relative p-0">
          <MenuBar />
        </div>

        {/* Title Section with Overlay */}
        <div className="container-fluid p-0">
          <div
            className="banner-image"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/images/Marian-Retreat-Centre-Banner.jpg)`,
            }}
          >
            <div className="banner-heading text-center wow fadeInDown">
              <h1 className="text-white">Marian Retreat Centre</h1>
            </div>
          </div>
        </div>

        {/* Content Section with Alternating Image and Text */}
        <div className="container my-5">
          <div className="row mb-5">
            <div className="col-12 col-md-6 order-md-2">
              <img
                className="img-fluid shadow-sm"
                src={`${process.env.PUBLIC_URL}/images/Main chapel.png`}        
                alt="Marian Retreat Centre Building"
              />
            </div>
            <div className="col-12 col-md-6 order-md-1 d-flex flex-column align-items-start">
              <p >
                Marian Retreat Centre was established in 2009 as a center for
                nurturing Catholic spirituality. Rev. Fr. Dominic Valanmanal, a
                Diocesan priest, was chosen to establish the center, which is
                situated in Anakkara within the state of Kerala in South India.
                Rev. Fr. Dominic is in charge of the center, which functions with
                the apostolic blessings of the Bishop of Kanjirapally H. E. Mar
                Jose Pulickal. Marian Retreat Centre, in the past one and a half
                decades, has served millions of people seeking deliverance and
                healing. In Mathew 12:48-50, Jesus reminds us that those who do
                the will of the heavenly Father are considered as Jesus’s brother
                and sister and mother. Marian Retreat Centre is the ideal place
                for receiving the Holy Spirit, leading to the freedom that is
                received only from the love of Jesus Christ.
              </p>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-12 col-md-6">
              <img
                className="img-fluid shadow-sm"
                src={`${process.env.PUBLIC_URL}/images/Rosa Mystica_2.png`}
                alt="Rosa Mystica"
              />
            </div>
            <div className="col-12 col-md-6 d-flex flex-column justify-content-center">
              <p >
                Marian Retreat Centre is dedicated to the maternal protection of
                Rosa Mystica, a poetic title given to Mother Mary. The name is
                synonymous with the spirit of Prayer, Penance, and Reparation—three
                essential things said by Mother Mary for reclaiming our lost
                relationship with God. The first recorded miracle in the Bible, in
                John 2:1-12, speaks of how the Lord and Mother Mary went to Cana to
                a wedding and saved it by converting water to wine. In its nascent
                years, Fr. Dominic had to go through many hardships for the Centre.
                Gradually, by the grace of God and word of mouth, people near and
                far came to the Centre. As Luke 15:4-7 says, the Lord loves the lost
                sheep and calls people to Him. For many, Marian Retreat Centre was
                the last ray of hope in their lives. They came in search of healing
                and deliverance. The Holy Spirit anointed Rev. Fr. Dominic with the
                apostolic Grace of Exorcism to serve them and free them from the
                bondage of the devil.
              </p>
            </div>
          </div>

          {/* Link Section */}
          <div className="text-end mt-4">
            <a
              href="https://marianretreatcentre.org/"
              className="btn btn-outline-primary btn-lg"
              style={{ textDecoration: 'none' }}
            >
              View More <i className="bi bi-arrow-right-circle"></i>
            </a>
          </div>
        </div>

        <FooterPanel />
      </React.Fragment>
    );
  }
}

export default MarianRetreatCentrePage;
